import request from '@/utils/request';

/**
 * @description: 用户相关接口
 */

// 登录
export const login = (data) => {
  return request.post('api/IndexUser/login', data);
};

// 注册
export const register = (data) => {
  return request.post('api/IndexUser/register', data);
};
